const switchTabs = (item, navigate) => {
  if (item.navigate) {
    navigate(item.navigate);
  }
};

const switchItems = [
  {
    label: 'AI Tasks',
    navigate: 'ai_tasks',
    value: 'ai_task',
    permission: 'ai_tasks.read'
  },
  {
    label: 'Prompt Template',
    navigate: 'prompts',
    value: 'prompts',
    permission: 'prompts.read'
  },
  {
    label: 'Models',
    navigate: 'models',
    value: 'model',
    permission: 'models.read'
  }
];

const checkActive = (location) => {
  const locationPathName = location.pathname.split('/').pop();
  return switchItems.find((i) => i.navigate == locationPathName);
};

module.exports = {
  switchTabs,
  switchItems,
  checkActive
};
